module.exports = __webpack_public_path__ + "static/img/icon-1691301_960_720.362c3e6a.png";